import React from "react";
import "./Testimonies.scss";

// Images
import success from "../../Assets/Images/successImg.png";

// Icons
import discordBlack from "../../Assets/Icons/discordBlack.svg";
import rating from "../../Assets/Icons/stars.svg";

function Testimonies({ review, memberType, user }) {
  return (
    <div id="testimonies">
      {/* <img className="successImg" src={success} alt="successImg" /> */}
      <div className="testimonyContent">
        <img className="stars" src={rating} alt="successImg" />
        <h2 className="reviewText">
          {review}
        </h2>

        <div className="reviewer">
          <img className="discord" src={discordBlack} alt="successImg" />
          <h3 className="nameText">{user}</h3>
        </div>
        <p className="frugalMember">{memberType}</p>

      </div>
    </div>
  );
}

export default Testimonies;
